import React, { Component } from "react";
import cn from "classnames";

import { IBarsortingData } from "../../../../../../../../common/types";
import { generatePath } from "../../../../../../../paths";

import { Container, Wrapper, Window, Bar } from "../shared-style";
import { getImageDimensions, IGetImageDimensionsThis } from "../methods";

import { IProps, IState } from "./interfaces";

class NonBars extends Component<IProps, IState> {
    img?: HTMLImageElement;
    constructor(props: IProps) {
        super(props);
        this.state = {
            width: 0,
            height: 0,
            zoom: 1,
        };
        const { taskIndex, editTask, task } = props;
        const { data } = task;
        if (!data.nonBars) {
            const { systems } = data;
            let nonBars: IBarsortingData["nonBars"] = [];
            systems!.starts.forEach((start, index) => {
                nonBars![index] = [];
            });
            editTask({ taskIndex, changingProp: "nonBars", val: nonBars });
            setTimeout(this.save, 100);
        }
    }

    selectNonBar = (index: number, barIndex: number) => {
        const { editTask, taskIndex, task } = this.props;
        const nonBars = [...task.data.nonBars!];
        let isContains = nonBars[index].findIndex(nonBar => nonBar === barIndex);
        if (isContains !== -1) {
            nonBars[index].splice(isContains, 1);
        } else {
            nonBars[index].push(barIndex);
            nonBars[index].sort((a, b) => a - b);
        }
        editTask({ taskIndex, changingProp: "nonBars", val: nonBars });
        this.save();
    };

    save = () => {
        const { plan, taskIndex, post, task } = this.props;
        const {
            data: { nonBars },
        } = task;
        post("score-editor-non-bars", {
            planId: plan._id,
            index: taskIndex,
            nonBars,
        });
    };

    render() {
        const { task: { data } } = this.props;
        const { score, systems, bars, nonBars } = data;
        const { width, height, zoom } = this.state;
        return (
            <Container>
                <Wrapper>
                    <img
                        src={generatePath(score!)}
                        ref={img => (this.img = img!)}
                        onLoad={() => getImageDimensions.call(this as unknown as IGetImageDimensionsThis)}
                        width={width}
                        height={height}
                        alt="score"
                    />
                    {!!width &&
                        !!height &&
                        systems!.starts.map((startY, index) => (
                            <Window
                                key={index}
                                style={{
                                    top: startY / zoom,
                                    height: systems!.height / zoom,
                                    left: 0,
                                    right: 0,
                                }}
                            >
                                {[...bars![index], width * zoom].map((bar, barIndex) => {
                                    let lastX = barIndex === 0 ? 0 : bars![index][barIndex - 1];
                                    let width = bar - lastX;
                                    return (
                                        <Bar
                                            key={barIndex}
                                            className={cn(
                                                nonBars![index] &&
                                                    nonBars![index].findIndex(nonBar => nonBar === barIndex) !== -1 &&
                                                    "Selected"
                                            )}
                                            style={{
                                                height: systems!.height / zoom,
                                                left: lastX / zoom,
                                                width: width / zoom,
                                            }}
                                            onClick={() => this.selectNonBar(index, barIndex)}
                                        />
                                    );
                                })}
                            </Window>
                        ))}
                </Wrapper>
            </Container>
        );
    }
}

export default NonBars;
